import { NavigationGuard } from "vue-router";
import { authStore } from "@/store/auth";

/**
 * 新規登録済みチェック処理
 * @param to
 * @param _from
 * @param next
 */
export const checkCompletedRegister: NavigationGuard = (to, _from, next) => {
  // ログイン済みかつ、新規登録が完了していない場合
  if (!authStore.user?.hasRegisteredProfile) {
    next({
      name: "RegisterPersonalInfo"
    });
    return;
  }
  next({
    name: "Search"
  });
};
